<div class="appLoader">
  <svg
    version="1.1"
    id="appLoaderLogo"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="-100 0 796 363"
    xml:space="preserve"
  >
    <g>
      <path
        d="M544.84 267.11L509.18 253.44C501.77 250.61 497.89 252.2 494.26 258.98C480.52 284.67 456.04 302.95 419.94 302.95C372.44 302.95 335.96 263.94 335.96 216.22C335.96 168.49 371.98 128.86 419.94 128.86C454.56 128.86 478.37 146.64 493.26 173.98C495.35 177.8 499.77 179.76 504.21 178.36C504.21 178.36 540.89 166.02 542.51 165.48C549.39 163.18 552.35 157.32 548.59 149.8C523.78 100.11 474.88 69.4099 419.95 69.4099C340.43 69.4099 275.74 135.26 275.74 216.21C275.74 297.14 340.43 362.98 419.95 362.98C477.52 362.98 525.94 330.91 549.9 282.56C553.47 275.34 552.03 269.84 544.84 267.11Z"
      />
      <path
        d="M60.29 185.94C60.29 185.59 60.74 185.45 60.94 185.74L176.11 355.33C178.25 358.46 181.35 360.24 185.5 360.24H239.28C246.32 360.24 250.1 355.85 250.1 349.77V82.2499C250.1 76.4999 246.24 72.1799 239.82 72.1799H200.07C194.02 72.1799 189.81 76.5499 189.81 83.6399V271.15C189.81 271.51 189.34 271.64 189.15 271.34L65 77.0499C63.04 74.0199 59.68 72.1799 56.05 72.1799H11.71C3.30002 72.1799 0 75.9299 0 83.6999V349.15C0 355.28 3.99998 360.23 10.54 360.23H49.4C56.15 360.23 60.29 355.8 60.29 349.04V185.94Z"
      />
      <path
        d="M622.551 0C582.351 0 549.771 32.59 549.771 72.78C549.771 112.98 582.361 145.56 622.551 145.56C662.751 145.56 695.331 112.97 695.331 72.78C695.341 32.59 662.751 0 622.551 0ZM622.551 117.99C597.581 117.99 577.341 97.75 577.341 72.78C577.341 47.81 597.581 27.57 622.551 27.57C647.521 27.57 667.76 47.81 667.76 72.78C667.76 97.75 647.521 117.99 622.551 117.99Z"
      />
    </g>
  </svg>
</div>
